import { render, staticRenderFns } from "./DetailsMatrix.vue?vue&type=template&id=6f63a26c&scoped=true&"
import script from "./DetailsMatrix.vue?vue&type=script&lang=js&"
export * from "./DetailsMatrix.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMatrix.vue?vue&type=style&index=0&id=6f63a26c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f63a26c",
  null
  
)

export default component.exports